import { HubHeader } from "./hub-header";
import { HubRouter } from "./hub-router";
import { useGetChannelMentorship } from "@/lib/hooks/conversations/use-get-channel-mentorship";
import { Loader2 } from "lucide-react";
import { NoMentorship } from "../shared/no-mentorship";
import { MentorshipDetails } from "@/lib/api/mentorships";
import { useAbility } from "@/lib/casl/ability-context";

interface HubProps {
  mentorship?: MentorshipDetails;
}

export function Hub({ mentorship }: HubProps) {
  const ability = useAbility();
  if (!ability.can("read", "shareable-entities")) return null;

  // If mentorship is provided externally (admin view), render directly
  // Otherwise, use the channel-based hook (mentor view)
  if (mentorship) {
    return <HubContent mentorship={mentorship} />;
  }

  return <HubWithChannel />;
}

// Used when we need to fetch mentorship from Sendbird channel context
function HubWithChannel() {
  const { mentorship, isLoading } = useGetChannelMentorship();

  if (isLoading) {
    return (
      <div className="flex h-full flex-col">
        <HubHeader />
        <div className="flex flex-1 items-center justify-center bg-white p-4">
          <Loader2 className="h-6 w-6 animate-spin text-primary" />
        </div>
      </div>
    );
  }

  if (!mentorship) {
    return (
      <div className="flex h-full flex-col">
        <HubHeader />
        <NoMentorship />
      </div>
    );
  }

  return <HubContent mentorship={mentorship} />;
}

// Pure render component - no Sendbird dependency
function HubContent({ mentorship }: { mentorship: MentorshipDetails }) {
  return (
    <div className="flex h-full flex-col">
      <HubHeader />
      <div className="flex flex-1 flex-col min-h-0">
        <HubRouter mentorship={mentorship} />
      </div>
    </div>
  );
}
